import { InsightData } from 'schemas/action/InsightDataSchema'

const getLabel = (insight: InsightData) => {
  switch (insight.id) {
    case '#1149361':
      return 'Afghanistan'
    case '#783754':
      return 'Albania'
    case '#2589581':
      return 'Algeria'
    case '#3041565':
      return 'Andorra'
    case '#3351879':
      return 'Angola'
    case '#3576396':
      return 'Antigua and Barbuda'
    case '#3865483':
      return 'Argentina'
    case '#174982':
      return 'Armenia'
    case '#2077456':
      return 'Australia'
    case '#2782113':
      return 'Austria'
    case '#587116':
      return 'Azerbaijan'
    case '#290291':
      return 'Bahrain'
    case '#1210997':
      return 'Bangladesh'
    case '#3374084':
      return 'Barbados'
    case '#630336':
      return 'Belarus'
    case '#2802361':
      return 'Belgium'
    case '#3582678':
      return 'Belize'
    case '#2395170':
      return 'Benin'
    case '#1252634':
      return 'Bhutan'
    case '#3923057':
      return 'Bolivia'
    case '#3277605':
      return 'Bosnia and Herzegovina'
    case '#933860':
      return 'Botswana'
    case '#3469034':
      return 'Brazil'
    case '#1820814':
      return 'Brunei'
    case '#732800':
      return 'Bulgaria'
    case '#2361809':
      return 'Burkina Faso'
    case '#433561':
      return 'Burundi'
    case '#1831722':
      return 'Cambodia'
    case '#2233387':
      return 'Cameroon'
    case '#6251999':
      return 'Canada'
    case '#3374766':
      return 'Cape Verde'
    case '#239880':
      return 'Central African Republic'
    case '#2434508':
      return 'Republic of Chad'
    case '#3895114':
      return 'Chile'
    case '#1814991':
      return 'China'
    case '#3686110':
      return 'Colombia'
    case '#921929':
      return 'Comoros'
    case '#3624060':
      return 'Costa Rica'
    case '#2287781':
      return "Cote d'Ivoire"
    case '#3202326':
      return 'Croatia'
    case '#3562981':
      return 'Cuba'
    case '#146669':
      return 'Cyprus'
    case '#3077311':
      return 'Czech Republic'
    case '#203312':
      return 'Democratic Republic of the Congo'
    case '#2623032':
      return 'Denmark'
    case '#223816':
      return 'Djibouti'
    case '#3575830':
      return 'Dominica'
    case '#3508796':
      return 'Dominican Republic'
    case '#1966436':
      return 'East Timor'
    case '#3658394':
      return 'Ecuador'
    case '#357994':
      return 'Egypt'
    case '#3585968':
      return 'El Salvador'
    case '#2309096':
      return 'Equatorial Guinea'
    case '#338010':
      return 'Eritrea'
    case '#453733':
      return 'Estonia'
    case '#337996':
      return 'Ethiopia'
    case '#2205218':
      return 'Fiji'
    case '#660013':
      return 'Finland'
    case '#3017382':
      return 'France'
    case '#2400553':
      return 'Gabon'
    case '#2413451':
      return 'Gambia'
    case '#614540':
      return 'Republic of Georgia'
    case '#2921044':
      return 'Germany'
    case '#2300660':
      return 'Ghana'
    case '#390903':
      return 'Greece'
    case '#3580239':
      return 'Grenada'
    case '#3595528':
      return 'Guatemala'
    case '#2420477':
      return 'Guinea'
    case '#2372248':
      return 'Guinea-Bissau'
    case '#3378535':
      return 'Guyana'
    case '#3723988':
      return 'Haiti'
    case '#3608932':
      return 'Honduras'
    case '#719819':
      return 'Hungary'
    case '#2629691':
      return 'Iceland'
    case '#1269750':
      return 'India'
    case '#1643084':
      return 'Indonesia'
    case '#130758':
      return 'Iran'
    case '#99237':
      return 'Iraq'
    case '#2963597':
      return 'Ireland'
    case '#294640':
      return 'Israel'
    case '#3175395':
      return 'Italy'
    case '#3489940':
      return 'Jamaica'
    case '#1861060':
      return 'Japan'
    case '#248816':
      return 'Jordan'
    case '#1522867':
      return 'Kazakhstan'
    case '#192950':
      return 'Kenya'
    case '#4030945':
      return 'Kiribati'
    case '#285570':
      return 'Kuwait'
    case '#1527747':
      return 'Kyrgyzstan'
    case '#1655842':
      return 'Laos'
    case '#458258':
      return 'Latvia'
    case '#272103':
      return 'Lebanon'
    case '#932692':
      return 'Lesotho'
    case '#2275384':
      return 'Liberia'
    case '#2215636':
      return 'Libya'
    case '#3042058':
      return 'Liechtenstein'
    case '#597427':
      return 'Lithuania'
    case '#2960313':
      return 'Luxembourg'
    case '#718075':
      return 'Republic of Macedonia'
    case '#1062947':
      return 'Madagascar'
    case '#927384':
      return 'Malawi'
    case '#1733045':
      return 'Malaysia'
    case '#1282028':
      return 'Maldives'
    case '#2453866':
      return 'Mali'
    case '#2562770':
      return 'Malta'
    case '#2080185':
      return 'Marshall Islands'
    case '#2378080':
      return 'Mauritania'
    case '#934292':
      return 'Mauritius'
    case '#3996063':
      return 'Mexico'
    case '#2081918':
      return 'Federated States of Micronesia'
    case '#617790':
      return 'Moldova'
    case '#2993457':
      return 'Monaco'
    case '#2029969':
      return 'Mongolia'
    case '#3194884':
      return 'Montenegro'
    case '#2542007':
      return 'Morocco'
    case '#1036973':
      return 'Mozambique'
    case '#1327865':
      return 'Myanmar'
    case '#3355338':
      return 'Namibia'
    case '#2110425':
      return 'Nauru'
    case '#1282988':
      return 'Nepal'
    case '#2750405':
      return 'Netherlands'
    case '#2186224':
      return 'New Zealand'
    case '#3617476':
      return 'Nicaragua'
    case '#2440476':
      return 'Niger'
    case '#2328926':
      return 'Nigeria'
    case '#1873107':
      return 'North Korea'
    case '#3144096':
      return 'Norway'
    case '#286963':
      return 'Oman'
    case '#1168579':
      return 'Pakistan'
    case '#1559582':
      return 'Palau'
    case '#3703430':
      return 'Panama'
    case '#2088628':
      return 'Papua New Guinea'
    case '#3437598':
      return 'Paraguay'
    case '#3932488':
      return 'Peru'
    case '#1694008':
      return 'Philippines'
    case '#798544':
      return 'Poland'
    case '#2264397':
      return 'Portugal'
    case '#289688':
      return 'Qatar'
    case '#2260494':
      return 'Republic of the Congo'
    case '#798549':
      return 'Romania'
    case '#2017370':
      return 'Russia'
    case '#49518':
      return 'Rwanda'
    case '#3575174':
      return 'Saint Kitts and Nevis'
    case '#3576468':
      return 'Saint Lucia'
    case '#3577815':
      return 'Saint Vincent and the Grenadines'
    case '#4034894':
      return 'Samoa'
    case '#3168068':
      return 'San Marino'
    case '#2410758':
      return 'Sao Tome and Principe'
    case '#102358':
      return 'Saudi Arabia'
    case '#2245662':
      return 'Senegal'
    case '#6290252':
      return 'Serbia'
    case '#241170':
      return 'Seychelles'
    case '#2403846':
      return 'Sierra Leone'
    case '#1880251':
      return 'Singapore'
    case '#3057568':
      return 'Slovakia'
    case '#3190538':
      return 'Slovenia'
    case '#2103350':
      return 'Solomon Islands'
    case '#51537':
      return 'Somalia'
    case '#953987':
      return 'South Africa'
    case '#1835841':
      return 'South Korea'
    case '#2510769':
      return 'Spain'
    case '#1227603':
      return 'Sri Lanka'
    case '#366755':
      return 'Sudan'
    case '#3382998':
      return 'Suriname'
    case '#934841':
      return 'Swaziland'
    case '#2661886':
      return 'Sweden'
    case '#2658434':
      return 'Switzerland'
    case '#163843':
      return 'Syria'
    case '#1220409':
      return 'Tajikistan'
    case '#149590':
      return 'Tanzania'
    case '#1605651':
      return 'Thailand'
    case '#2363686':
      return 'Togo'
    case '#4032283':
      return 'Tonga'
    case '#3573591':
      return 'Trinidad and Tobago'
    case '#2464461':
      return 'Tunisia'
    case '#298795':
      return 'Turkey'
    case '#1218197':
      return 'Turkmenistan'
    case '#2110297':
      return 'Tuvalu'
    case '#226074':
      return 'Uganda'
    case '#690791':
      return 'Ukraine'
    case '#290557':
      return 'United Arab Emirates'
    case '#2635167':
      return 'United Kingdom'
    case '#6252001':
      return 'United States'
    case '#3439705':
      return 'Uruguay'
    case '#1512440':
      return 'Uzbekistan'
    case '#2134431':
      return 'Vanuatu'
    case '#3625428':
      return 'Venezuela'
    case '#1562822':
      return 'Vietnam'
    case '#69543':
      return 'Yemen'
    case '#895949':
      return 'Zambia'
    case '#878675':
      return 'Zimbabwe'
    case '#1668284':
      return 'Taiwan'
    case '#831053':
      return 'Kosovo'
    case '#4030656':
      return 'French Polynesia'
    case '#6254930':
      return 'Palestinian territories'
    case '#4829764':
      return 'Alabama'
    case '#5879092':
      return 'Alaska'
    case '#5551752':
      return 'Arizona'
    case '#4099753':
      return 'Arkansas'
    case '#5332921':
      return 'California'
    case '#5417618':
      return 'Colorado'
    case '#4831725':
      return 'Connecticut'
    case '#4142224':
      return 'Delaware'
    case '#4155751':
      return 'Florida'
    case '#4197000':
      return 'Georgia'
    case '#5855797':
      return 'Hawaii'
    case '#5596512':
      return 'Idaho'
    case '#4896861':
      return 'Illinois'
    case '#4921868':
      return 'Indiana'
    case '#4862182':
      return 'Iowa'
    case '#4273857':
      return 'Kansas'
    case '#6254925':
      return 'Kentucky'
    case '#4331987':
      return 'Louisiana'
    case '#4971068':
      return 'Maine'
    case '#4361885':
      return 'Maryland'
    case '#6254926':
      return 'Massachusetts'
    case '#5001836':
      return 'Michigan'
    case '#5037779':
      return 'Minnesota'
    case '#4436296':
      return 'Mississippi'
    case '#4398678':
      return 'Missouri'
    case '#5667009':
      return 'Montana'
    case '#5073708':
      return 'Nebraska'
    case '#5509151':
      return 'Nevada'
    case '#5090174':
      return 'New Hampshire'
    case '#5101760':
      return 'New Jersey'
    case '#5481136':
      return 'New Mexico'
    case '#5128638':
      return 'New York'
    case '#4482348':
      return 'North Carolina'
    case '#5690763':
      return 'North Dakota'
    case '#5165418':
      return 'Ohio'
    case '#4544379':
      return 'Oklahoma'
    case '#5744337':
      return 'Oregon'
    case '#6254927':
      return 'Pennsylvania'
    case '#5224323':
      return 'Rhode Island'
    case '#4597040':
      return 'South Carolina'
    case '#5769223':
      return 'South Dakota'
    case '#4662168':
      return 'Tennessee'
    case '#4736286':
      return 'Texas'
    case '#5549030':
      return 'Utah'
    case '#5242283':
      return 'Vermont'
    case '#6254928':
      return 'Virginia'
    case '#5815135':
      return 'Washington'
    case '#4826850':
      return 'West Virginia'
    case '#5279468':
      return 'Wisconsin'
    case '#5843591':
      return 'Wyoming'
    case '#4138106':
      return 'District of Columbia'
    case '#5883102':
      return 'Alberta'
    case '#6065171':
      return 'Manitoba'
    case '#6354959':
      return 'Newfoundland and Labrador'
    case '#6091530':
      return 'Nova Scotia'
    case '#6093943':
      return 'Ontario'
    case '#6115047':
      return 'Quebec'
    case '#6185811':
      return 'Yukon Territory'
    case '#5909050':
      return 'British Columbia'
    case '#6087430':
      return 'New Brunswick'
    case '#6091069':
      return 'Northwest Territories'
    case '#6091732':
      return 'Nunavut'
    case '#6113358':
      return 'Prince Edward Island'
    case '#6141242':
      return 'Saskatchewan'
    case '#4019231':
      return 'Aguascalientes'
    case '#4017700':
      return 'Baja California'
    case '#4017698':
      return 'Baja California Sur'
    case '#3531730':
      return 'Campeche'
    case '#3531011':
      return 'Chiapas'
    case '#4014336':
      return 'Chihuahua'
    case '#4013674':
      return 'Coahuila'
    case '#4013513':
      return 'Colima'
    case '#3527646':
      return 'The Federal District'
    case '#4011741':
      return 'Durango'
    case '#4005267':
      return 'Guanajuato'
    case '#3527213':
      return 'Guerrero'
    case '#3527115':
      return 'Hidalgo'
    case '#4004156':
      return 'Jalisco'
    case '#3523272':
      return 'México'
    case '#3995955':
      return 'Michoacán'
    case '#3522961':
      return 'Morelos'
    case '#3995012':
      return 'Nayarit'
    case '#3522542':
      return 'Nuevo León'
    case '#3522509':
      return 'Oaxaca'
    case '#3521082':
      return 'Puebla'
    case '#3520914':
      return 'Querétaro'
    case '#3520887':
      return 'Quintana Roo'
    case '#3985605':
      return 'San Luis Potosí'
    case '#3983035':
      return 'Sinaloa'
    case '#3982846':
      return 'Sonora'
    case '#3516458':
      return 'Tabasco'
    case '#3516391':
      return 'Tamaulipas'
    case '#3515359':
      return 'Tlaxcala'
    case '#3514780':
      return 'Veracruz-Llave'
    case '#3514211':
      return 'Yucatán'
    case '#3979840':
      return 'Zacatecas'
    case 'Continent/#Africa':
      return 'Africa'
    case 'Continent/#Asia':
      return 'Asia'
    case 'Continent/#Americas':
      return 'Americas'
    case 'Continent/#Europe':
      return 'Europe'
    case 'Continent/#Oceania':
      return 'Oceania'
    case '#6697173':
      return 'Antarctica'
    case 'Continent/#NorthernAfrica':
      return 'Northern Africa'
    case 'Continent/#WesternAfrica':
      return 'Western Africa'
    case 'Continent/#CentralAfrica':
      return 'Middle Africa'
    case 'Continent/#EasternAfrica':
      return 'Eastern Africa'
    case 'Continent/#SouthernAfrica':
      return 'Southern Africa'
    case 'Continent/#NorthernEurope':
      return 'Northern Europe'
    case 'Continent/#WesternEurope':
      return 'Western Europe'
    case 'Continent/#EasternEurope':
      return 'Eastern Europe'
    case 'Continent/#SouthernEurope':
      return 'Southern Europe'
    case 'Continent/#NorthernAmerica':
      return 'Northern America'
    case 'Continent/#Caribbean':
      return 'Caribbean'
    case 'Continent/#CentralAmerica':
      return 'Central America'
    case 'Continent/#SouthAmerica':
      return 'South America'
    case 'Continent/#CentralAsia':
      return 'Central Asia'
    case 'Continent/#EasternAsia':
      return 'Eastern Asia'
    case 'Continent/#SouthernAsia':
      return 'Southern Asia'
    case 'Continent/#SouthEasternAsia':
      return 'South-Eastern Asia'
    case 'Continent/#WesternAsia':
      return 'Western Asia'
    case 'Continent/#Australasia':
      return 'Australia and New Zealand'
    case 'Continent/#Melanesia':
      return 'Melanesia'
    case 'Continent/#Micronesia':
      return 'Micronesia'
    case 'Continent/#Polynesia':
      return 'Polynesia'
    case 'unknown':
      return 'Unclassified'
    case '#4566966':
      return 'Puerto Rico'
    case '#1819730':
      return 'Hong Kong'
    case '#3573345':
      return 'Bermuda'
    case '#3572887':
      return 'Bahamas'
    case '#3577279':
      return 'Aruba'
    case '#7626836':
      return 'Curacao'
    case '#7626844':
      return 'Bonaire'
    case '#3573511':
      return 'Anguilla'
    case '#5880801':
      return 'American Samoa'
    case '#661882':
      return 'Aland Islands'
    case '#3578476':
      return 'Saint Barthelemy'
    case '#3371123':
      return 'Bouvet Island'
    case '#1547376':
      return 'Cocos Islands'
    case '#1899402':
      return 'Cook Islands'
    case '#2078138':
      return 'Christmas Island'
    case '#2461445':
      return 'Western Sahara'
    case '#3474414':
      return 'Falkland Islands'
    case '#2622320':
      return 'Faroe Islands'
    case '#3381670':
      return 'French Guiana'
    case '#3042362':
      return 'Guernsey'
    case '#2411586':
      return 'Gibraltar'
    case '#3425505':
      return 'Greenland'
    case '#3579143':
      return 'Guadeloupe'
    case '#3474415':
      return 'South Georgia and the South Sandwich Islands'
    case '#4043988':
      return 'Guam'
    case '#1547314':
      return 'Heard Island and McDonald Islands'
    case '#3042225':
      return 'Isle of Man'
    case '#1282588':
      return 'British Indian Ocean Territory'
    case '#3042142':
      return 'Jersey'
    case '#3580718':
      return 'Cayman Islands'
    case '#3578421':
      return 'Saint Martin'
    case '#1821275':
      return 'Macao'
    case '#4041468':
      return 'Northern Mariana Islands'
    case '#3570311':
      return 'Martinique'
    case '#3578097':
      return 'Montserrat'
    case '#2139685':
      return 'New Caledonia'
    case '#2155115':
      return 'Norfolk Island'
    case '#4036232':
      return 'Niue'
    case '#3424932':
      return 'Saint Pierre and Miquelon'
    case '#4030699':
      return 'Pitcairn'
    case '#935317':
      return 'Reunion'
    case '#3370751':
      return 'Saint Helena'
    case '#607072':
      return 'Svalbard and Jan Mayen'
    case '#7909807':
      return 'South Sudan'
    case '#7609695':
      return 'Sint Maarten'
    case '#3576916':
      return 'Turks and Caicos Islands'
    case '#1546748':
      return 'French Southern Territories'
    case '#4031074':
      return 'Tokelau'
    case '#5854968':
      return 'United States Minor Outlying Islands'
    case '#3164670':
      return 'Vatican'
    case '#3577718':
      return 'British Virgin Islands'
    case '#4796775':
      return 'U.S. Virgin Islands'
    case '#4034749':
      return 'Wallis and Futuna'
    case '#1024031':
      return 'Mayotte'
    default:
      return undefined
  }
}

export default getLabel
